import { GtmService } from './services/google/gtm.service';
import { NavigationEnd, Router } from '@angular/router';
import { ShareService } from './services/utility/sharer.service';
import { OverlayContainer } from '@angular/cdk/overlay';
import { Component, HostBinding, OnDestroy, OnInit, Renderer2 } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable, Subject, Subscription } from 'rxjs';
import { OverlayGmapService } from './services/utility/overlay/overlayGmap.service';
import { themes } from './services/utility/themes';
import { ThemingService } from './services/utility/theming.service';
import { UpdateService } from './services/utility/updateVersion.service';
import { GlobalActions } from './store/global/global.actions';
import { IconService } from './services/utility/icon.service';
import * as dominios from './utilitarios/dominios';
import { takeUntil } from 'rxjs/operators';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { Footer } from './store/global/global.state';
import { IntegrationsAction } from './store/integrations/integrations.actions';
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  unsubscribe$ = new Subject<void>();
  @Select((state: any) => state.global.slugInstitucion) slugInstitucion$!: Observable<any>;
  @Select((state: any) => state.global.nombreInstitucion) nombreInstitucion$!: Observable<any>;
  @Select((state: any) => state.global.institucionLoaded) loaded$!: Observable<any>;
  favIcon: any = document.querySelector('#faviconInstitucion');
  themingSubscription!: Subscription;
  rutaInstitucion!: string;
  slugInstitucion: any;
  faWhatsapp: any;
  mapa$: Observable<boolean> = this.store.select(
    (state) => state.global.openMap
  );
  @Select((state: any) => state.global.footer) footer$!: Observable<Footer>;
  constructor(
    private sw: UpdateService,
    private themingService: ThemingService,
    private renderer: Renderer2,
    private overlayContainer: OverlayContainer,
    private store: Store,
    private overlayService: OverlayGmapService,
    private iconService: IconService,
    private shareService: ShareService,
    private router: Router,
    private gtmService: GtmService,
  ) {
    /**Tomamos la raiz de la url con window.location.origin, lo convertimos a String 
    y buscamos el value correspondiente a la key (la url) en el Map de Dominios 
    */
    this.rutaInstitucion = window.location.host.toString();
    this.slugInstitucion = dominios.mapUrl.get(this.rutaInstitucion);
    this.store.dispatch(new GlobalActions.GetInstitucion(this.slugInstitucion));
    this.slugInstitucion$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((slug) => {
        if (slug) {
          this.store.dispatch([
            new GlobalActions.LoadLanding(slug)
          ])
            .pipe(takeUntil(this.unsubscribe$))
            .subscribe((global) => {
              /**Suscripcion a la respuesta global para cambiar favicon de header */
              if (global[0].global.faviconSrc) {
                this.favIcon.href = global[0].global.faviconSrc;
              }
            });
        }
      });
  }
  @HostBinding('class') public cssClass!: string;
  ngOnInit(): void {
    /**Trackeo de cambio de url para GtagManager */
    this.router.events.forEach(item => {
      if (item instanceof NavigationEnd) {
        this.gtmService.pageView(item.url);
      }
    });
    this.faWhatsapp = faWhatsapp;
    this.mapa$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((isOpen) => {
        if (isOpen) {
          this.overlayService.open();
        } else {
          this.overlayService.close();
        }
      });
    this.sw.checkForUpdates();
    this.themingSubscription = this.themingService.theme.subscribe(
      (theme: string) => {
        this.renderer.removeClass(document.body, this.cssClass);
        this.cssClass = theme;
        this.renderer.addClass(document.body, this.cssClass);
        this.applyThemeOnOverlays();
      }
    );
    this.store.dispatch(new IntegrationsAction.LoadIntegrations());
  }
  ngAfterViewInit(): void {
    this.iconService.registerFontAwsome();
  }
  private applyThemeOnOverlays() {
    // remove old theme class and add new theme class
    // we're removing any css class that contains '-theme' string but your theme classes can follow any pattern
    const overlayContainerClasses =
      this.overlayContainer.getContainerElement().classList;
    const themeClassesToRemove = Array.from(themes);
    if (themeClassesToRemove.length) {
      overlayContainerClasses.remove(...themeClassesToRemove);
    }
    overlayContainerClasses.add(this.cssClass);
  }
  ngOnDestroy() {
    this.themingSubscription.unsubscribe();
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  goWhatsapp(whatsapp: string) {
    this.shareService.shareWhatsapp(whatsapp, true, 'Hola, quiero realizar una consulta!');
  }
}
